
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    errorOccurred: 'An error occurred',
    retry: 'Try again',
  },
  ru: {
    errorOccurred: 'Произошла ошибка',
    retry: 'Повторить',
  },
  uz: {
    errorOccurred: 'Xatolik yuz berdi',
    retry: 'Qayta urinish',
  },
  fa: {
    errorOccurred: 'خطایی رخ داد',
    retry: 'دوباره تلاش کن',
  },
  pt: {
    errorOccurred: 'Ocorreu um erro',
    retry: 'Tentar de novo',
  },
  tr: {
    errorOccurred: 'Bir hata oluştu',
    retry: 'Tekrar dene',
  },
  uk: {
    errorOccurred: 'Сталася помилка',
    retry: 'Повторити',
  },
  de: {
    errorOccurred: 'Ein Fehler ist aufgetreten',
    retry: 'Nochmal versuchen',
  },
  es: {
    errorOccurred: 'Ha ocurrido un error',
    retry: 'Reintentar',
  },
  pl: {
    errorOccurred: 'Wystąpił błąd',
    retry: 'Spróbuj ponownie',
  },
});
